<template>
  <div>
    <!-- galaxsys settings -->
    <p class="title is-5">Galaxsys settings</p>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Lobby url</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="galaxsysSettings.lobbyUrl" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Demo currency</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="galaxsysSettings.demoCurrency" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Real username</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="galaxsysSettings.realUsername" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Demo username</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="galaxsysSettings.demoUsername" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Dummy birth date</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="galaxsysSettings.dummyBirthDate" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label">
      </div>
      <div class="field-body">
        <div class="field is-grouped">
          <div class="control">
            <button @click="save" class="button is-primary">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import galaxsysService from '../../../../services/galaxsys.service';

  export default {
    name: 'client-settings-galaxsys',
    data() {
      return {
        galaxsysSettings: {
        }
      }
    },
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      }
    },
    async mounted() {
      this.galaxsysSettings = await galaxsysService.getSettingsByClient(this.clientId);
    },
    methods: {
      async save() {
        await galaxsysService.save(this.clientId, this.galaxsysSettings);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/galaxsys.vue